<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h2>Add New Post</h2>
      <AddElement category_id="1"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewPost",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Posts',
          to: '/posts/all'
        }, {
          text: 'Add Post',
          href: '#'
        }
      ],
    };
  },
};
</script>